module.exports = __webpack_public_path__ + "img/404.11ed1efd.png";